module.exports = __webpack_public_path__ + "static/slide10_1.bdf6cbca.png";